module.exports = __webpack_public_path__ + "static/media/be-on-the-beat.f8f01645.txt";